module.exports = __webpack_public_path__ + "b1ef210bc5a723bdea45e7dddfda72bc.svg";